import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

// Shared collapse/scroll/expand behavior for Dashboard widget lists (Harus Di-Follow Up
// Hari Ini, Jadwal Aktivitas, …): shows only ~`visibleCount` rows worth of height by
// default with the rest reachable by scrolling INSIDE that small box (no data is hidden,
// just visually capped), plus a "Lihat Semua" toggle that drops the height cap to show the
// complete list flowing normally. `expanded` is local component state — the widget
// unmounts on page navigation (different route), so leaving the Dashboard and coming back
// always starts collapsed again, never stuck open.
export default function CollapsibleWidgetList({ items, renderItem, visibleCount = 2, rowHeight = 64, gap = 8, testId = "cwl" }) {
  const [expanded, setExpanded] = useState(false);
  if (!items.length) return null;
  const maxHeight = visibleCount * rowHeight + (visibleCount - 1) * gap;
  return (
    <div>
      <div data-testid={`${testId}-list`} className={expanded ? "space-y-2" : "space-y-2 overflow-y-auto pr-0.5"}
        style={expanded ? undefined : { maxHeight }}>
        {items.map(renderItem)}
      </div>
      {items.length > visibleCount && (
        <button type="button" data-testid={`${testId}-toggle`} onClick={() => setExpanded((v) => !v)}
          className="w-full flex items-center justify-center gap-1 text-[11px] font-medium text-blue-300 hover:text-blue-200 pt-2 mt-2 border-t border-white/5">
          {expanded ? <>Sembunyikan <ChevronUp size={13} /></> : <>Lihat Semua ({items.length}) <ChevronDown size={13} /></>}
        </button>
      )}
    </div>
  );
}
